import { useMutation } from '@apollo/client';
import { getUploadUrlMutation } from '@libs/graphql';
import { useApiResponse } from './useApiResponse';
export const useUploadFile = (onSuccess, icon, onError) => {
    const [getUploadUrl, getUploadUrlResponse] = useMutation(getUploadUrlMutation);
    const onUploadUrlSuccess = async (data) => {
        const url = data?.getUploadUrl;
        if (url) {
            fetch(url, {
                method: 'PUT',
                body: icon,
            }).then(() => {
                onSuccess(url.split('?')[0]);
            });
        }
        else {
            //TODO: error handling
        }
    };
    const { errorMessage, loading } = useApiResponse(getUploadUrlResponse, onUploadUrlSuccess, onError);
    const uploadFile = (extension, type) => {
        getUploadUrl({
            variables: {
                record: { extension, type },
            },
        });
    };
    return {
        uploadFile,
        errorMessage,
        loading,
    };
};
//# sourceMappingURL=useUploadFile.js.map